import { 
  fetchOrderCenterDetails, 
  fetchOrderCenterFee, 
  fetchOrderCenterAssociation 
} from '../../api/order-center'

export default {
  state: {
    details: {
      data: [],
      total_recharge_amount: null,
      total_withdraw_amount: null,
      total_bonus_amount: null,
      total_fee_amount: null
    },
    fee: [],
    association: [],
  },
  getters: {},
  mutations: {
    setDetailsData(state, data) {
      state.details.data = data
    },
    setTotalRechargeAmount(state, data) {
      state.details.total_recharge_amount = data
    },
    setTotalWithdrawAmount(state, data) {
      state.details.total_withdraw_amount = data
    },
    setTotalBonusAmount(state, data) {
      state.details.total_bonus_amount = data
    },
    setTotalFeeAmount(state, data) {
      state.details.total_fee_amount = data
    },
    setFeeData(state, data) {
      state.fee = data
    },
    setAssociationData(state, data) {
      state.association = data
    }
  },
  actions: {
    getOrderCenter(context) {
      fetchOrderCenterDetails().then(res => {
        context.commit('setDetailsData', res.details)
        context.commit('setTotalRechargeAmount', res.total_recharge_amount)
        context.commit('setTotalWithdrawAmount', res.total_withdraw_amount)
        context.commit('setTotalBonusAmount', res.total_bonus_amount)
        context.commit('setTotalFeeAmount', res.total_fee_amount)
      })
      fetchOrderCenterFee().then(res => {
        context.commit('setFeeData', res.fee)
      })
      fetchOrderCenterAssociation().then(res => {
        context.commit('setAssociationData', res.association)
      })
    }
  }
}


// WEBPACK FOOTER //
// ./src/vuex/modules/orderCenter.js